const EMAIL_RE = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const EMAIL_ALLOWED_CHARS_RE = /^[a-zA-Z0-9._%+@-]*$/;
const DISPLAY_NAME_ALLOWED_CHARS_RE = /^[a-zA-Z0-9 _-]*$/;

export function validateEmail(email: string): string | null {
  if (!email.trim()) return 'Email is required';
  if (!EMAIL_ALLOWED_CHARS_RE.test(email)) {
    return 'Only Latin letters, numbers and . _ % + - @ are allowed';
  }
  if (!EMAIL_RE.test(email)) return 'Invalid email format';
  return null;
}

export function validatePassword(password: string): string | null {
  if (!password) return 'Password is required';
  if (password.length < 8) return 'Minimum 8 characters';
  return null;
}

export function validateDisplayName(displayName: string): string | null {
  if (!displayName.trim()) return 'Name is required';
  if (!DISPLAY_NAME_ALLOWED_CHARS_RE.test(displayName)) {
    return 'Only Latin letters, numbers, spaces, - and _ are allowed';
  }
  if (displayName.trim().length < 2) return 'Minimum 2 characters';
  return null;
}

/** Strips characters that are not allowed in an email field, for use in onChange. */
export function sanitizeEmailInput(value: string): string {
  return value.replace(/[^a-zA-Z0-9._%+@-]/g, '');
}

/** Strips characters that are not allowed in a display-name field, for use in onChange. */
export function sanitizeDisplayNameInput(value: string): string {
  return value.replace(/[^a-zA-Z0-9 _-]/g, '');
}